<template>
    <div>
        <tsoft-table
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="false"
            :isNeedCreate="isNeedCreate"
            :additionalGetParameter="additionalGetParameter"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right-dadata-check"
            right
            backdrop
            shadow
            width="80%"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="setClosedSidePanel()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__">
                        Проверка компании #{{ detailedItem.company_id }}
                    </strong>
                </div>
            </template>
            <div class="d-block">
                <template v-if="detailedItem.id">
                    <CompanyDadataCheckDetails
                        :itemId="detailedItem.id"
                    />
                </template>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_COMPANY_DADATA_CHECK } from "@/constants"
    import CompanyDadataCheckDetails from '@/components/companies/CompanyDadataCheckDetails.vue'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '@/mixins'

    const initialEditedItem = () => ({
        'id': '',
        'company_id': null,
        'inn': '',
        'is_liquidated': false,
        'is_processed': false,
        'dadata_data': '',
    })

    export default {
        props: {
            isNeedCreate: { type: Boolean, required: false, default: false },    // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &company_id=10
        },
        components: {
            'CompanyDadataCheckDetails': CompanyDadataCheckDetails,
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem
        ],
          data() {
            return {
                changeLoad: false,
                isSidebarOpenDetail: false,
                tableApiUrl: API_COMPANY_DADATA_CHECK,
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
            this.initialAssign()
        },
        methods: {
            initialAssign() {
            },
            // rewrite showItem from actions.js
            showItem(index, tabSelector = '', name) {
                let id = this.items.data[index].id;
            
                api.call("get", `${this.tableApiUrl}/${id}`).then(({data}) => {
                    this.detailedItem = data
                    this.isSidebarOpenDetail = true
                    this.detailedItemIndex = index
                    // If this element exist in table lets update
                    if (typeof this.items !== 'undefined' && this.items.data[index]) {
                        this.items.data[index] = Object.assign(this.items.data[index], data)
                    }
                }).finally(() => {
                    if (tabSelector != '') {
                        // $(tabSelector).tab('show')
                        $(tabSelector)[0].click()
                    }
                })
            },
            setCreatedItem(data) {
                this.items.data.unshift(data)
                this.editedItem = initialEditedItem()
            },
            setUpdatedItem(data) {
                Object.assign(this.items.data[this.editIndex], data)
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setClosedSidePanel(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
        }
    }
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.buttons {
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;

  @media screen and (max-width: 991px) {
    margin-left: 0;
  }
}

.textarea-form {
  min-width: 400px;
  @media screen and (max-width: 991px) {
    min-width: 100%;
  }
}

.title {
  margin-bottom: 0;

  @media screen and (max-width: 991px) {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    font-size: 1.1rem;
    margin-left: -40px;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 65px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }
}
</style>